import * as i0 from '@angular/core';
import { Injectable, Directive, Input, Component, ContentChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { register } from 'swiper/element/bundle';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = a0 => ({
  height: a0
});
function SwiperComponent_For_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SwiperComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "swiper-slide");
    i0.ɵɵtemplate(1, SwiperComponent_For_2_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const slide_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", slide_r1.template);
  }
}
let NgxSwiperjsService = /*#__PURE__*/(() => {
  class NgxSwiperjsService {
    constructor() {}
    static {
      this.ɵfac = function NgxSwiperjsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxSwiperjsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxSwiperjsService,
        factory: NgxSwiperjsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxSwiperjsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwiperDirective = /*#__PURE__*/(() => {
  class SwiperDirective {
    constructor(el) {
      this.el = el;
      this.swiperElement = el.nativeElement;
    }
    ngAfterViewInit() {
      if (!this.el || !this.el.nativeElement) {
        return;
      }
      Object.assign(this.el.nativeElement, this.config);
      // @ts-ignore
      if (this.el.nativeElement?.initialize) {
        // @ts-ignore
        this.el.nativeElement?.initialize();
      }
      // @ts-ignore
      if (this.el.nativeElement?.swiper?.autoplay) {
        // @ts-ignore
        this.el.nativeElement.swiper.autoplay.start();
      }
    }
    static {
      this.ɵfac = function SwiperDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwiperDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SwiperDirective,
        selectors: [["", "ngxSwiper", ""]],
        inputs: {
          config: "config"
        },
        standalone: false
      });
    }
  }
  return SwiperDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SlideDirective = /*#__PURE__*/(() => {
  class SlideDirective {
    constructor(template) {
      this.template = template;
    }
    static {
      this.ɵfac = function SlideDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SlideDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SlideDirective,
        selectors: [["", "ngx-swiper-slide", ""]],
        standalone: false
      });
    }
  }
  return SlideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SwiperComponent = /*#__PURE__*/(() => {
  class SwiperComponent {
    constructor() {
      this.config = {};
      this.height = '600px';
    }
    static {
      this.ɵfac = function SwiperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SwiperComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SwiperComponent,
        selectors: [["ngx-swiper"]],
        contentQueries: function SwiperComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SlideDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slides = _t);
          }
        },
        inputs: {
          config: "config",
          height: "height"
        },
        standalone: false,
        decls: 3,
        vars: 4,
        consts: [["ngxSwiper", "", 3, "config", "ngStyle"], [4, "ngTemplateOutlet"]],
        template: function SwiperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "swiper-container", 0);
            i0.ɵɵrepeaterCreate(1, SwiperComponent_For_2_Template, 2, 1, "swiper-slide", null, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("config", ctx.config)("ngStyle", i0.ɵɵpureFunction1(2, _c0, ctx.height));
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.slides);
          }
        },
        dependencies: [i1.NgTemplateOutlet, i1.NgStyle, SwiperDirective],
        styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   swiper-container[_ngcontent-%COMP%]   swiper-slide[_ngcontent-%COMP%]{width:fit-content;height:100%;max-width:100%}"]
      });
    }
  }
  return SwiperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
register();
let NgxSwiperjsModule = /*#__PURE__*/(() => {
  class NgxSwiperjsModule {
    static {
      this.ɵfac = function NgxSwiperjsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxSwiperjsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgxSwiperjsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return NgxSwiperjsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-swiperjs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSwiperjsModule, NgxSwiperjsService, SlideDirective, SwiperComponent, SwiperDirective };
